/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserProfileResponse
 */
export interface GetUserProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    countryState?: string;
    /**
     * ISO 3166-1 alpha-2 country code.
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    officeName: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserProfileResponse
     */
    officeLogo?: string | null;
}

/**
 * Check if a given object implements the GetUserProfileResponse interface.
 */
export function instanceOfGetUserProfileResponse(value: object): value is GetUserProfileResponse {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('officeName' in value) || value['officeName'] === undefined) return false;
    return true;
}

export function GetUserProfileResponseFromJSON(json: any): GetUserProfileResponse {
    return GetUserProfileResponseFromJSONTyped(json, false);
}

export function GetUserProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserProfileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'],
        'countryState': json['countryState'] == null ? undefined : json['countryState'],
        'country': json['country'] == null ? undefined : json['country'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'phoneNumber': json['phoneNumber'],
        'officeName': json['officeName'],
        'website': json['website'] == null ? undefined : json['website'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
        'officeLogo': json['officeLogo'] == null ? undefined : json['officeLogo'],
    };
}

export function GetUserProfileResponseToJSON(json: any): GetUserProfileResponse {
    return GetUserProfileResponseToJSONTyped(json, false);
}

export function GetUserProfileResponseToJSONTyped(value?: GetUserProfileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'countryState': value['countryState'],
        'country': value['country'],
        'timezone': value['timezone'],
        'phoneNumber': value['phoneNumber'],
        'officeName': value['officeName'],
        'website': value['website'],
        'avatar': value['avatar'],
        'officeLogo': value['officeLogo'],
    };
}

